export * from './trim.directive';